import ForgotPasswordModal from './ForgotPasswordModal'

export { ForgotPasswordModal }
export default ForgotPasswordModal
